var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddToLibrary(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 12a1 1 0 011-1h4a1 1 0 011 1v3a1 1 0 01-1 1h-4a1 1 0 01-1-1v-3zm2 1v1h2v-1h-2z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 9a2.5 2.5 0 100-5 2.5 2.5 0 000 5zM10 5a1 1 0 011-1h4a1 1 0 110 2h-4a1 1 0 01-1-1zM11 7a1 1 0 100 2h4a1 1 0 100-2h-4z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1a1 1 0 011-1h18a1 1 0 011 1v18a1 1 0 01-1 1h-7v-2h6V2H2v6H0V1z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.955 12A1.044 1.044 0 018 13.029v5.926a1.045 1.045 0 01-2.09 0l.258-3.645-4.385 4.384a1.045 1.045 0 01-1.477-1.477l4.385-4.384-3.646.257a1.045 1.045 0 010-2.09h5.91z",
    fill: "#fff"
  })));
}
export default __webpack_public_path__ + "fonts/add-to-library-a2d74e3bacca7757d8a414a1bd627db6.svg";
export { SvgAddToLibrary as ReactComponent };